import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=92edfb72&scoped=true&"
import script from "./DepartmentList.vue?vue&type=script&lang=js&"
export * from "./DepartmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92edfb72",
  null
  
)

export default component.exports